<template>
  <div class="col-xl-6 col-lg-8 col-sm-12">
    <div class="mb-3">
      <label>Lugar del evento <span class="text-danger">*</span></label>
      <div class="input-group">
        <vee-field
          class="form-select"
          name="place_code"
          as="select"
          v-model="selectedPlace"
          @change="handlePlaceChange"
        >
          <option value="" disabled>Seleccione una opción</option>
          <option
            v-for="place in activePlaces"
            :value="place.id"
            :key="place.id"
          >
            {{ place.description }} (Capacidad: {{ place.capacity }})
          </option>
        </vee-field>
        <slot name="modal-create"></slot>
      </div>
      <ErrorMessage class="text-danger" name="place_code" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";

const props = defineProps({
  places: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: [String, Number],
    default: "",
  },
  fieldName: {
    type: String,
    default: "place_code",
  },
});

const emit = defineEmits(["update:modelValue", "capacity-change"]);

const selectedPlace = ref(props.modelValue);

const activePlaces = computed(() => {
  return props.places.filter((place) => place.state !== false);
});

const capacity = computed(() => {
  if (!selectedPlace.value) return 0;
  const place = props.places.find((p) => p.id == selectedPlace.value);
  return place ? place.capacity : 0;
});

const handlePlaceChange = (event) => {
  const value = event?.target?.value || selectedPlace.value;
  selectedPlace.value = value;
  emit("update:modelValue", value);
  const place = props.places.find((p) => p.id == value);
  const newCapacity = place ? place.capacity : 0;
  emit("capacity-change", newCapacity);
};

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== selectedPlace.value) {
      selectedPlace.value = newVal;
    }
  }
);

watch(selectedPlace, (newVal) => {
  if (newVal) {
    const place = props.places.find((p) => p.id == newVal);
    const newCapacity = place ? place.capacity : 0;
    emit("capacity-change", newCapacity);
  }
});

onMounted(() => {
  if (selectedPlace.value) {
    const place = props.places.find((p) => p.id == selectedPlace.value);
    const initialCapacity = place ? place.capacity : 0;
    emit("capacity-change", initialCapacity);
  }
});

const clearSelection = () => {
  selectedPlace.value = "";
  emit("update:modelValue", "");
  emit("capacity-change", 0);
};

defineExpose({
  clearSelection,
  capacity,
});
</script>
